<template>
   <layout-main :banner="banner" subtitle="联系我们">
    <template v-slot:content>
    <div class="contactUs container">
      <el-row class="contactMap" type="flex">
          <div class="map">
            <h5>南京迪孚网络科技有限公司</h5>
            <baidu-map
              :center="center"
              :zoom="zoom"
              @ready="handler"
              style="height:400px;"
              @click="getClickInfo"
              :scroll-wheel-zoom="true"
            >
              <bm-info-window :position="center" title="南京迪孚网络科技有限公司" :show="infoWindow.show">
                <p v-text="infoWindow.contents"></p>
              </bm-info-window>
            </baidu-map>
            <div class="address">
              <div class="addressL">
                <p>
                  地址：
                  <span>南京市江宁区东山街道万泰路39号宸泰科技大厦宸空间7楼705室</span>
                </p>
                <p>
                  咨询：
                  <span>13813359066 （工作日9:00—18:00）</span>
                </p>
                <p>
                  邮箱：
                  <a href="mailto:market@njdifu.com"><span>market@njdifu.com</span></a>
                </p>
              </div>
            </div>
          </div>
      </el-row>
    </div>
    </template>
  </layout-main>

  
</template>
<script>
import layoutMain from '@/components/layout-main.vue'
import banner from '@/assets/contactUs/banner.png'
export default {
  name: 'JoinUs',
  components: {
    layoutMain
  },
  data () {
    return {
      center: { lng: 118.882194, lat: 31.995554 },
      infoWindow: {
        show: true,
        contents: '南京市江宁区东山街道万泰路',
       
      },
      zoom: 20,
       banner: banner
    }
  },
  methods: {
    handler ({ BMap, map }) {
      const that = this
      that.infoWindow.show = true
      var point = new BMap.Point(118.882194, 31.995554)
      map.centerAndZoom(point, 20)
      var marker = new BMap.Marker(point) // 创建标注
      map.addOverlay(marker) // 将标注添加到地图中
      // var circle = new BMap.Circle(point, 6, {
      //   strokeColor: 'Red',
      //   strokeWeight: 6,
      //   strokeOpacity: 1,
      //   Color: 'Red',
      //   fillColor: '#f03'
      // })
      // map.addOverlay(circle)
      // 标注的点击事件
      marker.addEventListener('click', function (event) {
        console.log('--------------event', event.point.lng)
        // that.infoWindow.show = true
        that.center.lng = event.point.lng
        that.center.lat = event.point.lat
      })
    },
    getClickInfo (e) {
      console.log(e.point.lng)
      console.log(e.point.lat)
      // this.center.lng = e.point.lng
      // this.center.lat = e.point.lat
    }
  }
}
</script>
<style lang="scss" scoped>
.contactUs {
    .contactMap {
      margin:60px 0;
      background: #f3f3f3;
      justify-content: center;
      .map {
        width:100%;
        min-height: 600px;
        background: #fff;
        padding-top: 0;
        border: 1px solid #ccc;
        h5 {
          font-size: 24px;
          padding: 30px 0;
          margin-left:10px;
          text-align: left;
        }
        .boxMap {
          width: 100%;
          height: 600px;
        }
        .address {
          display: flex;
          justify-content: space-between;
          padding: 20px;
          .addressL {
            p {
              font-size: 18px;
              line-height: 40px;
              text-align: left;
              font-weight: 600;
              span {
                font-weight: 400;
              }
            }
          }
          .addressR {
            img {
              width: 200px;
            }
          }
        }
      }
    }
    .contactWay {
      justify-content: center;
      text-align: left;
      font-size: 14px;
      padding: 40px 0;
      h6 {
        font-size: 20px;
        margin-bottom: 8px;
      }
      .center_phone {
        margin-bottom: 16px;
      }
    }
    .message {
      justify-content: center;
      .messageCont {
        border-top: 1px solid #ccc;
        position: relative;
        p {
          font-size: 28px;
          position: absolute;
          left: 0;
          top:-22px;
          background:#fff;
        }
        ul{
          display:table;
          border-collapse:collapse;
          margin:30px 0;
          li{
            display:table-cell;
            width:280px;
            height:80px;
            line-height:80px;
            font-size:22px;
            cursor: pointer;
            border:1px solid #eee;
            .font1{
            }
            .font2{
              font-size:18px;
              display:none;
              vertical-align:middle;
              img{
                position: relative;
                top:28px;
              }
            }
          }
          li:hover{
            .font1{
              display:none;
            }
            .font2{
              display:block;
            }
          }
        }
      }
    }
}
</style>
